// extracted by mini-css-extract-plugin
export var bold = "text-module--bold--3f3c7";
export var eyebrow = "text-module--eyebrow--c83c9";
export var eyebrow2 = "text-module--eyebrow2--a85a1";
export var h1 = "text-module--h1--b64a9";
export var h2 = "text-module--h2--a4efb";
export var h3 = "text-module--h3--ece55";
export var h4 = "text-module--h4--68b24";
export var h5 = "text-module--h5--ad19a";
export var h6 = "text-module--h6--64111";
export var italic = "text-module--italic--c101f";
export var menu = "text-module--menu--ca22c";
export var p1 = "text-module--p1--440db";
export var p2 = "text-module--p2--af509";
export var p3 = "text-module--p3--bcff0";
export var p4 = "text-module--p4--a11e8";
export var p5 = "text-module--p5--bdf46";
export var underline = "text-module--underline--10d21";